<template>
  <div class="action-menu" v-click-outside="close" :class="{ disabled }">
    <div
      class="action-menu-container"
      @click="!disabled ? (open = !open) : null"
      :class="[color]"
    >
      <slot />

      <transition name="menufade" mode="out-in">
        <div
          v-show="open"
          ref="itemsContainer"
          class="items-container"
          :class="[position, { above: isAbove }]"
        >
          <slide-up-down :active="open" :duration="300">
            <div
              class="item"
              :class="{
                selected: item.selected,
                disabled: item.disabled,
                divider: item.divider,
              }"
              :style="{ color: item.textColor }"
              v-for="(item, itemIndex) in items"
              @click.stop.prevent="emitter(item, itemIndex)"
              :key="itemIndex"
            >
              <p>{{ item.title }}</p>
            </div>
          </slide-up-down>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import ClickOutside from 'vue-click-outside'
import SlideUpDown from 'vue-slide-up-down'
export default {
  name: 'ActionMenu',
  props: ['items', 'color', 'position', 'disabled'],
  components: { SlideUpDown },
  data() {
    return {
      open: false,
      showConfirmation: -1,
      openSubItem: null,
      isAbove: false,
    }
  },
  watch: {
    escapePressed() {
      this.open = false
    },
    open: function (val) {
      if (val) {
        this.isAbove = false
        this.$nextTick(() => {
          this.adjustDropdownPosition()
        })
      }
    },
  },
  methods: {
    adjustDropdownPosition() {
      const dropdown = this.$refs.itemsContainer
      const dropdownRect = dropdown.getBoundingClientRect()
      const viewportHeight = window.innerHeight

      // + 12 is to match the absolute positioning from the element
      if (dropdownRect.bottom + 12 > viewportHeight) {
        this.isAbove = true
      }
    },
    emitter(item, index) {
      if (!item.disabled && !item.selected) {
        this.close()
        setTimeout(() => {
          this.$emit(item.action, item.value)
        }, 300)
      }
    },
    close() {
      this.open = false
    },
  },
  computed: {
    escapePressed() {
      return this.$store.getters.escapePressed
    },
  },
  directives: {
    ClickOutside,
  },
}
</script>

<style lang="scss" scoped>
@import '@/styles/Typography';

.menufade-enter-active,
.menufade-leave-active {
  transition: opacity 0.3s;
}

.menufade-enter,
.menufade-leave-to {
  opacity: 0;
}

.slideinleft-enter-active {
  animation: slide-in-left 0.3s;
}

.slideinleft-leave-active {
  animation: slide-in-left 0.3s reverse;
}

.slideinright-enter-active {
  animation: slide-in-right 0.3s;
}

.slideinright-leave-active {
  animation: slide-in-right 0.3s reverse;
}

@keyframes slide-in-left {
  0% {
    left: -100%;
    opacity: 0;
  }

  100% {
    left: 0;
    opacity: 1;
  }
}

@keyframes slide-in-right {
  0% {
    right: -100%;
    opacity: 0;
  }

  100% {
    right: 10px;
    opacity: 1;
  }
}

.action-menu {
  position: relative;
  cursor: pointer;

  &.disabled {
    cursor: default;
  }
}

.items-container {
  padding: 4px;
  border-radius: 7px;
  position: absolute;
  top: calc(100% + 12px);
  right: 0;
  white-space: nowrap;
  background: white;
  width: auto;
  z-index: 999999;
  border-radius: 6px;
  z-index: 1;
  max-width: 280px;
  box-shadow: 0px 0px 30px #00000034;

  &.above {
    top: unset;
    bottom: calc(100% + 12px);
  }

  &.left {
    left: 0;
    right: unset;
  }
  &.center {
    left: 50%;
    transform: translateX(-50%);
    right: unset;
  }

  .item {
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    background-color: white;
    @include Gilroy-Regular;
    position: relative;
    border-radius: 6px;
    z-index: 1;
    transition: all ease 0.3s;
    max-width: calc(100%);

    &:hover {
      transition: all ease 0.3s;
      background-color: $mist;
    }

    &.divider {
      position: relative;
      margin-top: 8px;

      &::before {
        content: '';
        width: calc(100% - 24px);
        height: 1px;
        background-color: $fog;
        position: absolute;
        top: -4px;
        left: 8px;
      }
    }

    p {
      text-overflow: ellipsis;
      white-space: nowrap;
      @include Gilroy-Medium;
      padding: 10px 12px;
      overflow: hidden;
      font-size: 16px;
      max-width: calc(100%);
    }

    &.disabled {
      color: $sleet !important;
      user-select: none;

      &:hover {
        transition: all ease 0.3s;
        background-color: transparent;
        cursor: default;
      }
    }

    &.selected {
      color: $midnight;
      background-color: $cloud;

      &:hover {
        transition: all ease 0.3s;
        background-color: $cloud;
        cursor: default;
      }
    }
  }
}

.action-menu-container {
  position: relative;

  span {
    display: flex;
    justify-content: center;
    flex-direction: row;
    align-items: center;
    height: 32px;
    width: 32px;
    border-radius: 12px;
    transition: all ease 0.3s;

    &:hover {
      padding: 2px;
      border-radius: 20px;
      background-color: $fog;
    }

    svg {
      width: 24px;
    }

    .a {
      fill: #e7e9ec;
      opacity: 0;
    }

    .b {
      fill: #2d323c;
    }
  }

  .dot {
    width: 4px;
    height: 4px;
    background-color: $midnight;
    margin: 0 1px;
    border-radius: 50%;
  }
}

.bounce-enter-active {
  animation: bounce-in 0.3s;
}

.bounce-leave-active {
  animation: bounce-in 0.3s reverse;
}

@media (min-width: 480px) and (orientation: landscape) {
}

@media (min-width: 544px) {
}

@media (min-width: 768px) {
  .action-menu-container {
    span {
      padding: 3px;
      border-radius: 20px;
      transition: all ease 0.3s;

      &:hover {
        padding: 3px;
        border-radius: 20px;
        background-color: $fog;
      }

      svg {
        width: unset;
      }

      .a {
        fill: #e7e9ec;
        opacity: 0;
      }

      .b {
        fill: #2d323c;
      }
    }
  }
}
</style>
